import { useEffect, useState } from 'react';
import { Container, SkipLink } from 'nhsuk-react-components';
import { Outlet, useNavigate } from 'react-router-dom';
import PageFooter from 'components/Footer/Footer.tsx';
import ScrollToTop from 'components/ScrollToTop';
import HomeHeader from 'components/HomeHeader/HomeHeader.tsx';
import Confirm from 'components/Confirm';
import useAuth from 'hooks/useAuth.ts';
import { INTENDED_URL } from 'constants/links.ts';
import { isValidInternalPath } from 'utils/validatorUtils.ts';

function PageLayout() {
  const navigate = useNavigate();
  const { cis2TimeOutWarning } = useAuth();
  const [showSessionTimeoutDialog, setShowSessionTimeoutDialog] = useState(false);

  useEffect(() => {
    if (cis2TimeOutWarning) {
      setShowSessionTimeoutDialog(true);
    }
  }, [cis2TimeOutWarning]);

  useEffect(() => {
    const intendedUrl = sessionStorage.getItem(INTENDED_URL);
    sessionStorage.removeItem(INTENDED_URL);
    if (intendedUrl && isValidInternalPath(intendedUrl)) {
      navigate(intendedUrl, { replace: true });
    }
  }, [navigate]);

  return (
    <div>
      <SkipLink />
      <HomeHeader />
      <Container>
        <div className="nhsuk-u-margin-top-6">
          <Outlet />
          <ScrollToTop />
        </div>
      </Container>
      <PageFooter />
      {showSessionTimeoutDialog && (
        <Confirm
          title="Your session will end in 10 minutes"
          message="You may lose your progress if you do not save it."
          onYes={() => setShowSessionTimeoutDialog(false)}
          yesText="I understand"
        />
      )}
    </div>
  );
}

export default PageLayout;
